export default __webpack_public_path__ + "static/media/icon_eyes_open_20.dd61ffa9.svg";